import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M18.75 22.916H14.5833V27.0827H18.75V22.916ZM27.0833 22.916H22.9167V27.0827H27.0833V22.916ZM35.4167 22.916H31.25V27.0827H35.4167V22.916ZM39.5833 8.33268H37.5V4.16602H33.3333V8.33268H16.6667V4.16602H12.5V8.33268H10.4167C8.10417 8.33268 6.27083 10.2077 6.27083 12.4993L6.25 41.666C6.25 43.9577 8.10417 45.8327 10.4167 45.8327H39.5833C41.875 45.8327 43.75 43.9577 43.75 41.666V12.4993C43.75 10.2077 41.875 8.33268 39.5833 8.33268ZM39.5833 41.666H10.4167V18.7493H39.5833V41.666Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
